import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

import { Row, Col, Spin } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'
import FilterTitle from '../title'

export const IconWrapper = styled.div`
  background: ${props => props.theme.colors.color2.bg};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledSVG = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${greys.light4};
`

const FilterItemWrapper = styled(Col)`
  cursor: pointer;
  color: ${props => props.theme.colors.color2.bg};
  margin-bottom: 15px;
  font-size: ${font.size.sm};
  line-height: 18px;
  &.activ {
    color: ${props => props.theme.colors.color1.bg};
    ${IconWrapper} {
      background: ${props => props.theme.colors.color1.bg};
    }
  }
`

/************* */

const Gearbox = props => {
  const { intl, loading, onChangeFilter, filters, filtersDatas } = props

  const { transmissions } = filters
  const transmissionsList = filtersDatas.transmissions

  const handleClick = item => {
    const isSelected = !transmissions
      ? false
      : transmissions.filter(el => el === item.id).length > 0

    let extendedGearboxesValues = transmissions ? [...transmissions] : []

    if (!isSelected) {
      extendedGearboxesValues.push(item.id)
    } else {
      extendedGearboxesValues = transmissions.filter(el => el !== item.id)
    }

    const extendedFiltersValues = {
      ...filters,
      transmissions: extendedGearboxesValues
    }
    onChangeFilter(extendedFiltersValues)
  }

  const renderIcon = id => {
    let icon

    switch (id) {
      case '00180001':
        icon = svg.gearboxes.manual
        break
      case '00180004':
        icon = svg.gearboxes.automatic
        break
      default:
        break
    }
    return icon ? (
      <IconWrapper>
        <StyledSVG svg={icon} data-test="stock-vehicles-list-filters-gearbox-FilterItemIcon" />
      </IconWrapper>
    ) : null
  }

  const renderItem = item => {
    const { wording, id } = item

    const isSelected = !transmissions
      ? false
      : transmissions.filter(el => el === item.id).length > 0

    return (
      <FilterItemWrapper
        key={id}
        onClick={() => handleClick(item)}
        className={isSelected ? 'activ' : ''}
        span={12}
        data-test="stock-vehicles-list-filters-gearbox-FilterItemWrapper"
      >
        <Row type="flex" gutter={10} justify="center">
          <Col>{renderIcon(id)}</Col>
          <Col>{wording}</Col>
        </Row>
      </FilterItemWrapper>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-gearbox">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-gearbox-title'
        })}
        data-test="stock-vehicles-list-filters-gearbox-title"
      />
      <Row type="flex" justify={loading ? 'center' : null}>
        {loading && <Spin />}
        {!loading && transmissionsList && transmissionsList.map(item => renderItem(item))}
      </Row>
    </div>
  )
}

Gearbox.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Gearbox)
